

<template>
    <!-- 用法说明
        <template>
            <pagination
                :total="count"
                :page-size="pageSize"
                @change="pageChange"
                ref="pager">
            </pagination>
        </template>

        <script>
            export default {
                data() {
                    return {
                        pageSize: 10, // 展示条数
                        count : 0, //总记录数
                    }
                },
                components:{
                    pagination,
                },
                mounted(){

                },
                methods: {
                    pageChange (param) {
                        this.params.pageSize = param.pageSize; // 发送给接口的字段
                        this.params.pageIndex = param.pageIndex-1; // 发送给接口的字段
                        this.getList();
                    },
                }
            }
        </script>
    -->
    <!-- 分页[[ -->
    <div class="g-pagination" v-if="total != 0">
        <a href="javascript:;" class="page-prev ico ico-paging-left" @click="prev"></a>

        <div class="pager">
            <a
                class="number"
                @click="first"
                v-show="index > perPages - (perPages-1)/2 && pages > perPages"
            >1</a>

            <a class="number" v-if="showPrevMore">...</a>

            <a
                class="number"
                :class="[{'active-number' : index === pager}]"
                v-for="(pager,curIndex) in pagers"
                @click="go(pager)"
                :key="curIndex"
            >{{ pager }}</a>

            <a class="number" v-if="showNextMore">...</a>

            <a
                class="number"
                @click="last"
                v-show="index <= pages-(perPages+1)/2 && pages > perPages"
            >{{pages}}</a>
        </div>

        <a href="javascript:;" class="page-next ico ico-paging-right" @click="next"></a>

        <div class="page-control">
            <span>跳转到</span>
            <input
                class="page-input"
                type="text"
                v-model.number="gotoPage"
                @keyup.enter="go(gotoPage)"
                @blur="go(gotoPage)"
            >
            <span>页</span>
        </div>
    </div>
    <!-- 分页]] -->
</template>
<style lang='scss' scoped>
// @import '~Assets/sass/components/pagination/pagination.scss';
.pager .number {
    cursor: pointer;
}
</style>
<script>
export default {
    name: "pagination",
    //通过props来接受从父组件传递过来的值
    props: {
        //页面中的可见页码，其他的以...替代, 必须是奇数
        perPages: {
            type: Number,
            default: 5
        },

        //当前页码
        pageIndex: {
            type: Number,
            default: 1
        },

        //每页显示条数
        pageSize: {
            type: Number,
            default: 10
        },

        //总记录数
        total: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            limit: this.pageSize, //每页显示条数
            index: this.pageIndex, //当前页码
            size: this.total || 0, //总记录数
            showPrevMore: false,
            showNextMore: false,
            gotoPage: null
        };
    },
    methods: {
        prev() {
            if (this.index > 1) {
                this.go(this.index - 1);
            }
        },
        next() {
            if (this.index < this.pages) {
                this.go(this.index + 1);
            }
        },
        first() {
            if (this.index !== 1) {
                this.go(1);
            }
        },
        last() {
            if (this.index != this.pages) {
                this.go(this.pages);
            }
        },
        go(page) {
            if (page > this.pages) {
                this.gotoPage = this.pages;
                page = this.pages;
            }
            if (page < 1) {
                this.gotoPage = 1;
                page = 1;
            }

            if (this.index !== page) {
                this.index = page;
                this.emitContent();
            }
            this.gotoPage = "";
        },
        emitContent() {
            //父组件通过change方法来接受当前的参数
            this.$emit("change", {
                pageIndex: this.index,
                pageSize: this.limit
            });
        },
        reload() {
            this.index = this.pageIndex;
        }
    },
    mounted() {
        // this.emitContent();
    },
    computed: {
        //计算总页码
        pages() {
            return Math.ceil(this.size / this.limit);
        },
        //计算页码，当count等变化时自动计算
        pagers() {
            let array = [];
            let perPages = this.perPages;
            let pageCount = this.pages;
            let current = this.index;
            let _offset = (perPages - 1) / 2;

            let offset = {
                start: current - _offset,
                end: current + _offset
            };

            //-1, 3
            if (offset.start < 1) {
                offset.end = offset.end + (1 - offset.start);
                offset.start = 1;
            }
            if (offset.end > pageCount) {
                offset.start = offset.start - (offset.end - pageCount);
                offset.end = pageCount;
            }
            if (offset.start < 1) offset.start = 1;

            this.showPrevMore = offset.start > 1;
            this.showNextMore = offset.end < pageCount;

            for (let i = offset.start; i <= offset.end; i++) {
                array.push(i);
            }

            return array;
        }
    },
    watch: {
        pageIndex(val) {
            this.index = val || 1;
        },
        limit(val) {
            this.limit = val || 10;
            this.index = 1;
            // this.go(this.index);
            // this.index = 1;
            this.emitContent();
        },
        total(val) {
            this.size = val || 1;
        }
    }
};
</script>
